import { FC } from 'react';

import { Button, ButtonProps } from '@atom/mui';
import colors from '@atom/styles/colors';
import layout from '@atom/styles/layout';

const ChatPrimaryButton: FC<ButtonProps> = ({
  variant = 'contained',
  size = 'medium',
  sx: sxProp,
  ...rest
}) => {
  return (
    <Button
      variant={variant}
      size={size}
      {...rest}
      sx={{
        textTransform: 'none',
        margin: '0.5rem 0',
        backgroundColor: colors.neutral.typhoon,
        color: colors.neutral.dim,
        boxShadow: layout.muiContainedButtonBoxShadow,
        '&:hover': {
          backgroundColor: colors.neutral.ash,
          boxShadow: layout.muiContainedButtonBoxShadow,
        },
        ...sxProp,
      }}
    />
  );
};

export default ChatPrimaryButton;
